import { useEffect } from "react";

export const APP_NAME = "E-NEX ontology";

/** Put a name for the screen in the browser tab, after the name of the app. Restored when the screen closes. */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    const before = document.title;
    document.title = `${title} – ${APP_NAME}`;
    return () => {
      document.title = before;
    };
  }, [title]);
}
